import React from 'react';
import Button from '@mui/material/Button';
import Icon from 'components/system/Icon';
import colors from 'styles/colors';

const styles = {
  exportButton: {
    marginBottom: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '12px 24px',
    borderRadius: '24px',
  },
};

const DownLoadButton = ({
  buttonText, onClick, sx, disabled, ...rest
}) => (
  <Button
    sx={{
      ...styles.exportButton,
      ...sx,
    }}
    variant="contained"
    type="secondary"
    onClick={onClick}
    endIcon={<Icon name="download" color={disabled ? 'rgba(96, 94, 245, 0.5)' : colors.primary.main} size="20px" />}
    disabled={disabled}
    {...rest}
  >
    {buttonText}

  </Button>
);

export default DownLoadButton;
